import { useRouter as useNextRouter } from 'next/router';

import { extractBusinessUnit } from '~/utils/extractBusinessUnit';

export function useRouter() {
  const router = useNextRouter();

  return {
    ...router,
    ...extractBusinessUnit(router.asPath),
  };
}
